import CONFIG from 'Config';

export default {
  screenWidth: state => state.screenWidth,
  isBigTablet: state => state.screenWidth < CONFIG.breakpoints.lg,
  isTablet: state => state.screenWidth < CONFIG.breakpoints.md,
  isMobile: state => state.screenWidth <= CONFIG.breakpoints.sm,
  scrollOffsetTop: (state, getters) => (getters.isMobile ? -70 : -75),
  isActiveItem: state => state.isActiveItem,
  // TODO: Move to config
  isIE: () => Boolean(/* @cc_on!@ */false || document.documentMode),
  // TODO: Move to config
  isFireFox: () => Boolean(navigator.userAgent ? navigator.userAgent.toLowerCase().indexOf('firefox') > -1 : false),
  screenHeight: state => state.screenHeight,
  portraitOrientation: state => state.portraitOrientation,
  isSmallScreen: state => state.screenWidth < 1170,
  isOpenCloseNotificationMenu: state => state.isOpenCloseNotificationMenu,
  isDocumentsBannerClosed: state => state.isDocumentsBannerClosed,
  isOpenMobileMenu: state => state.isOpenMobileMenu,
};
